/* eslint-disable no-useless-escape */
const OBLIGATION_REGEX_OPTIONS = [
  '^([A-Z]{1}[0-9]{4}|[0-9]{5}|[A-Z]{2}[-][0-9]{2}[-][0-9]{0,1})[0-9]{4}$',
  '^(Y)[0-9]{6}$',
  '^(Z)[0-9]{6}$',
  '^(2[8-9]|[3-7][0-9]|8[0-5])[0-9]{8}$',
  '^\\s*(0[0-9]|1[0-9]|2[0-7]|86)[0-9]{8}\\s*$',
  '^(A)[0-9]{10}$',
  '^(G)[0-9]{9}$',
  '^(P)[0-9]{9}$',
  '^(T)[0-9A-Za-z]{1,9}([0-9])$',
  '^\\s*(?=[0135])\\d{9}\\s*$',
];

export const CONTACT_NUMBER_REGEX = new RegExp('^[0-9]+$');

// This is a negative lookahead regular expression to now allow ^<> in email fields
export const EMAIL_SPECIAL_CHARS_REGEX = new RegExp(/^(?!.*[\^<>]).*$/);

export const NAME_FIELDS_REGEX = new RegExp('^([a-zA-Z]+)( [a-zA-Z]*)*$');
// For Given name and Family name fields restrict input to a maximum of 80 characters, including:[A-Za-z0-9]-'.space
export const NAME_FIELDS_NEW_REGEX = new RegExp(/^[\w\s.'-]{0,80}$/);
// a maximum of 75 characters, including:[A-Za-z0-9]@#\()$%*&=-.,?!-:;"'/|space
export const ORGANISATION_NAME_REGEX = new RegExp(/^[\w\s@#\\()$%*&=\-.,?!:;"'\/|]+$/);

export const FIELDS_WITH_SEPCIFI_CHARS = new RegExp('^((?!<|>).)*$');

// eslint-disable-next-line import/prefer-default-export
export const OBLIGATION_REGEX = new RegExp(OBLIGATION_REGEX_OPTIONS.join('|'));

export const TEN_DIGITS_OBLIGATIONS = new RegExp('^\\d{10}$');

export const VEHICLE_REGISTRATION_REGEX = new RegExp('^[A-Z0-9]+$');

export const ADDRESS_SEARCH_REGEX = new RegExp(/^[\w\s:.;,' -\/\\()]+$/);
export const COMPANY_NAME_REGEX = new RegExp(/^[\w\s@#\\() $%*&=\\-\\.,?!-:"'/]+$/);
export const FREE_TEXT_FIELD_REGEX = new RegExp(/^[\w\s$:%.;,"@&?'#= !_\/\\-\\-()]+$/);
export const POSITION_IN_COMPANY_REGEX = new RegExp(/^[\w\s'-.,. ]+$/);
export const POST_CODE_REGEX = new RegExp(/^[\w\s]+$/);
export const ADDRESS_FIELD_CHARS_REGEX = new RegExp(/^[\w\s:.;,'-/\\()& -]+$/);
export const NAMES_FIELDS_REGEX = new RegExp(/^[\w\s.'-]+$/);

export const ABN_ACN_REGEX = new RegExp('^[0-9]+$');

export const CRN_REGEX = new RegExp('^\\d{9}[a-zA-Z]$');

export const ONLY_NUMBERS_REGEX = new RegExp('^[0-9]+$');
export const ABN_ACN_REGEX_NOMINATION = new RegExp('^[0-9 ]+$');
